// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { AskGetabstractAnswer, AskGetabstractAnswerContextDoc, ActionableMiniView, AskGetabstractAnswerStatus, AskGetabstractQuestionAnswers } from "../schema";

export function serialize_AskGetabstractQuestionAnswers(obj: AskGetabstractQuestionAnswers): string {
  const serialized = ((value: { current: AskGetabstractAnswer; history: AskGetabstractAnswer[] }): unknown => {
    return {
      current: ((value: {
        answer: string;
        contextDocs: AskGetabstractAnswerContextDoc[];
        detectedLanguageLabel: string | null;
        previousQuestionUuid: string | null;
        question: string;
        questionUuid: string;
        relatedActionables: ActionableMiniView[];
        relatedQuestions: string[];
        status: AskGetabstractAnswerStatus;
      }): unknown => {
        return {
          answer: ((value: string): unknown => {
            return value;
          })(value["answer"]),
          contextDocs: ((value: AskGetabstractAnswerContextDoc[]): unknown => {
            return value.map(
              (value: {
                bookmarked: boolean;
                dataId: number;
                rating: number | null;
                referenceNumber: number;
                snippet: string;
                sourceTypeString: string;
                title: string;
                urls: {
                  cover: string;
                  list: string;
                  reference: string;
                };
              }): unknown => {
                return {
                  bookmarked: ((value: boolean): unknown => {
                    return value;
                  })(value["bookmarked"]),
                  dataId: ((value: number): unknown => {
                    return value;
                  })(value["dataId"]),
                  rating: ((value: number | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value;
                  })(value["rating"]),
                  referenceNumber: ((value: number): unknown => {
                    return value;
                  })(value["referenceNumber"]),
                  snippet: ((value: string): unknown => {
                    return value;
                  })(value["snippet"]),
                  sourceTypeString: ((value: string): unknown => {
                    return value;
                  })(value["sourceTypeString"]),
                  title: ((value: string): unknown => {
                    return value;
                  })(value["title"]),
                  urls: ((value: { cover: string; list: string; reference: string }): unknown => {
                    return {
                      cover: ((value: string): unknown => {
                        return value;
                      })(value["cover"]),
                      list: ((value: string): unknown => {
                        return value;
                      })(value["list"]),
                      reference: ((value: string): unknown => {
                        return value;
                      })(value["reference"]),
                    };
                  })(value["urls"]),
                };
              },
            );
          })(value["contextDocs"]),
          detectedLanguageLabel: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["detectedLanguageLabel"]),
          previousQuestionUuid: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["previousQuestionUuid"]),
          question: ((value: string): unknown => {
            return value;
          })(value["question"]),
          questionUuid: ((value: string): unknown => {
            return value;
          })(value["questionUuid"]),
          relatedActionables: ((value: ActionableMiniView[]): unknown => {
            return value.map((value: { actionableId: bigint; coverUri: string; name: string; title: string }): unknown => {
              return {
                actionableId: ((value: bigint): unknown => {
                  return value;
                })(value["actionableId"]),
                coverUri: ((value: string): unknown => {
                  return value;
                })(value["coverUri"]),
                name: ((value: string): unknown => {
                  return value;
                })(value["name"]),
                title: ((value: string): unknown => {
                  return value;
                })(value["title"]),
              };
            });
          })(value["relatedActionables"]),
          relatedQuestions: ((value: string[]): unknown => {
            return value.map((value: string): unknown => {
              return value;
            });
          })(value["relatedQuestions"]),
          status: ((value: "PROCESSING" | "FINISHED" | "NO_DOCS_FROM_VECTOR_DB" | "NO_DOCS_AFTER_FILTER" | "NO_REFERENCE_IN_ANSWER" | "GENERAL_ERROR" | "TIMEOUT"): unknown => {
            return value;
          })(value["status"]),
        };
      })(value["current"]),
      history: ((value: AskGetabstractAnswer[]): unknown => {
        return value.map(
          (value: {
            answer: string;
            contextDocs: AskGetabstractAnswerContextDoc[];
            detectedLanguageLabel: string | null;
            previousQuestionUuid: string | null;
            question: string;
            questionUuid: string;
            relatedActionables: ActionableMiniView[];
            relatedQuestions: string[];
            status: AskGetabstractAnswerStatus;
          }): unknown => {
            return {
              answer: ((value: string): unknown => {
                return value;
              })(value["answer"]),
              contextDocs: ((value: AskGetabstractAnswerContextDoc[]): unknown => {
                return value.map(
                  (value: {
                    bookmarked: boolean;
                    dataId: number;
                    rating: number | null;
                    referenceNumber: number;
                    snippet: string;
                    sourceTypeString: string;
                    title: string;
                    urls: {
                      cover: string;
                      list: string;
                      reference: string;
                    };
                  }): unknown => {
                    return {
                      bookmarked: ((value: boolean): unknown => {
                        return value;
                      })(value["bookmarked"]),
                      dataId: ((value: number): unknown => {
                        return value;
                      })(value["dataId"]),
                      rating: ((value: number | null): unknown => {
                        if (value === null) {
                          return null;
                        }
                        return value;
                      })(value["rating"]),
                      referenceNumber: ((value: number): unknown => {
                        return value;
                      })(value["referenceNumber"]),
                      snippet: ((value: string): unknown => {
                        return value;
                      })(value["snippet"]),
                      sourceTypeString: ((value: string): unknown => {
                        return value;
                      })(value["sourceTypeString"]),
                      title: ((value: string): unknown => {
                        return value;
                      })(value["title"]),
                      urls: ((value: { cover: string; list: string; reference: string }): unknown => {
                        return {
                          cover: ((value: string): unknown => {
                            return value;
                          })(value["cover"]),
                          list: ((value: string): unknown => {
                            return value;
                          })(value["list"]),
                          reference: ((value: string): unknown => {
                            return value;
                          })(value["reference"]),
                        };
                      })(value["urls"]),
                    };
                  },
                );
              })(value["contextDocs"]),
              detectedLanguageLabel: ((value: string | null): unknown => {
                if (value === null) {
                  return null;
                }
                return value;
              })(value["detectedLanguageLabel"]),
              previousQuestionUuid: ((value: string | null): unknown => {
                if (value === null) {
                  return null;
                }
                return value;
              })(value["previousQuestionUuid"]),
              question: ((value: string): unknown => {
                return value;
              })(value["question"]),
              questionUuid: ((value: string): unknown => {
                return value;
              })(value["questionUuid"]),
              relatedActionables: ((value: ActionableMiniView[]): unknown => {
                return value.map((value: { actionableId: bigint; coverUri: string; name: string; title: string }): unknown => {
                  return {
                    actionableId: ((value: bigint): unknown => {
                      return value;
                    })(value["actionableId"]),
                    coverUri: ((value: string): unknown => {
                      return value;
                    })(value["coverUri"]),
                    name: ((value: string): unknown => {
                      return value;
                    })(value["name"]),
                    title: ((value: string): unknown => {
                      return value;
                    })(value["title"]),
                  };
                });
              })(value["relatedActionables"]),
              relatedQuestions: ((value: string[]): unknown => {
                return value.map((value: string): unknown => {
                  return value;
                });
              })(value["relatedQuestions"]),
              status: ((value: "PROCESSING" | "FINISHED" | "NO_DOCS_FROM_VECTOR_DB" | "NO_DOCS_AFTER_FILTER" | "NO_REFERENCE_IN_ANSWER" | "GENERAL_ERROR" | "TIMEOUT"): unknown => {
                return value;
              })(value["status"]),
            };
          },
        );
      })(value["history"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_AskGetabstractQuestionAnswers(str: string): ParserResult<AskGetabstractQuestionAnswers> {
  return ((
    value: unknown,
  ): ParserResult<{
    current: AskGetabstractAnswer;
    history: AskGetabstractAnswer[];
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/AskGetabstractQuestionAnswers]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractQuestionAnswers]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "current")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractQuestionAnswers/current]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'current'.` };
    }
    const parsed_current = ((): ParserResult<AskGetabstractAnswer> => {
      return ((value: unknown): ParserResult<AskGetabstractAnswer> => {
        return ((
          value: unknown,
        ): ParserResult<{
          answer: string;
          contextDocs: AskGetabstractAnswerContextDoc[];
          detectedLanguageLabel: string | null;
          previousQuestionUuid: string | null;
          question: string;
          questionUuid: string;
          relatedActionables: ActionableMiniView[];
          relatedQuestions: string[];
          status: AskGetabstractAnswerStatus;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "answer")) {
            return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/answer]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'answer'.` };
          }
          const parsed_answer = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/answer]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["answer"]);
          })();
          if (!parsed_answer.success) {
            return { success: false, reason: parsed_answer.reason };
          }
          if (!hasProp(value, "contextDocs")) {
            return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/contextDocs]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contextDocs'.` };
          }
          const parsed_contextDocs = ((): ParserResult<AskGetabstractAnswerContextDoc[]> => {
            return ((value: unknown): ParserResult<AskGetabstractAnswerContextDoc[]> => {
              if (!isArray(value)) {
                return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/contextDocs]: '${value}' expected to be an array.` };
              }
              const parsed = value.map((value: unknown): ParserResult<AskGetabstractAnswerContextDoc> => {
                return ((
                  value: unknown,
                ): ParserResult<{
                  bookmarked: boolean;
                  dataId: number;
                  rating: number | null;
                  referenceNumber: number;
                  snippet: string;
                  sourceTypeString: string;
                  title: string;
                  urls: {
                    cover: string;
                    list: string;
                    reference: string;
                  };
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "bookmarked")) {
                    return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/bookmarked]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'bookmarked'.` };
                  }
                  const parsed_bookmarked = ((): ParserResult<boolean> => {
                    return ((value: unknown): ParserResult<boolean> => {
                      if (typeof value !== "boolean") {
                        return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/bookmarked]: '${value}' expected to be of type boolean.` };
                      }
                      return { success: true, value: value };
                    })(value["bookmarked"]);
                  })();
                  if (!parsed_bookmarked.success) {
                    return { success: false, reason: parsed_bookmarked.reason };
                  }
                  if (!hasProp(value, "dataId")) {
                    return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/dataId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'dataId'.` };
                  }
                  const parsed_dataId = ((): ParserResult<number> => {
                    return ((value: unknown): ParserResult<number> => {
                      if (typeof value === "number") {
                        return { success: true, value: value };
                      }
                      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/dataId]: '${value}' expected to be of type number.` };
                    })(value["dataId"]);
                  })();
                  if (!parsed_dataId.success) {
                    return { success: false, reason: parsed_dataId.reason };
                  }
                  if (!hasProp(value, "rating")) {
                    return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/rating]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'rating'.` };
                  }
                  const parsed_rating = ((): ParserResult<number | null> => {
                    return ((value: unknown): ParserResult<number | null> => {
                      if (value === null) {
                        return { success: true, value: null };
                      }
                      if (typeof value === "number") {
                        return { success: true, value: value };
                      }
                      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/rating]: '${value}' expected to be of type number.` };
                    })(value["rating"]);
                  })();
                  if (!parsed_rating.success) {
                    return { success: false, reason: parsed_rating.reason };
                  }
                  if (!hasProp(value, "referenceNumber")) {
                    return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/referenceNumber]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'referenceNumber'.` };
                  }
                  const parsed_referenceNumber = ((): ParserResult<number> => {
                    return ((value: unknown): ParserResult<number> => {
                      if (typeof value === "number") {
                        return { success: true, value: value };
                      }
                      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/referenceNumber]: '${value}' expected to be of type number.` };
                    })(value["referenceNumber"]);
                  })();
                  if (!parsed_referenceNumber.success) {
                    return { success: false, reason: parsed_referenceNumber.reason };
                  }
                  if (!hasProp(value, "snippet")) {
                    return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/snippet]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'snippet'.` };
                  }
                  const parsed_snippet = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/snippet]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["snippet"]);
                  })();
                  if (!parsed_snippet.success) {
                    return { success: false, reason: parsed_snippet.reason };
                  }
                  if (!hasProp(value, "sourceTypeString")) {
                    return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/sourceTypeString]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'sourceTypeString'.` };
                  }
                  const parsed_sourceTypeString = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/sourceTypeString]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["sourceTypeString"]);
                  })();
                  if (!parsed_sourceTypeString.success) {
                    return { success: false, reason: parsed_sourceTypeString.reason };
                  }
                  if (!hasProp(value, "title")) {
                    return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
                  }
                  const parsed_title = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/title]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["title"]);
                  })();
                  if (!parsed_title.success) {
                    return { success: false, reason: parsed_title.reason };
                  }
                  if (!hasProp(value, "urls")) {
                    return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'urls'.` };
                  }
                  const parsed_urls = ((): ParserResult<{
                    cover: string;
                    list: string;
                    reference: string;
                  }> => {
                    return ((
                      value: unknown,
                    ): ParserResult<{
                      cover: string;
                      list: string;
                      reference: string;
                    }> => {
                      if (typeof value !== "object") {
                        return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls]: '${value}' expected to be of type 'object'.` };
                      }
                      if (value === null) {
                        return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls]: '${value}' expected to not be null.` };
                      }
                      if (!hasProp(value, "cover")) {
                        return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls/cover]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'cover'.` };
                      }
                      const parsed_cover = ((): ParserResult<string> => {
                        return ((value: unknown): ParserResult<string> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls/cover]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["cover"]);
                      })();
                      if (!parsed_cover.success) {
                        return { success: false, reason: parsed_cover.reason };
                      }
                      if (!hasProp(value, "list")) {
                        return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls/list]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'list'.` };
                      }
                      const parsed_list = ((): ParserResult<string> => {
                        return ((value: unknown): ParserResult<string> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls/list]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["list"]);
                      })();
                      if (!parsed_list.success) {
                        return { success: false, reason: parsed_list.reason };
                      }
                      if (!hasProp(value, "reference")) {
                        return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls/reference]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'reference'.` };
                      }
                      const parsed_reference = ((): ParserResult<string> => {
                        return ((value: unknown): ParserResult<string> => {
                          if (typeof value !== "string") {
                            return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls/reference]: '${value}' expected to be of type string.` };
                          }
                          return { success: true, value: value };
                        })(value["reference"]);
                      })();
                      if (!parsed_reference.success) {
                        return { success: false, reason: parsed_reference.reason };
                      }
                      return { success: true, value: { cover: parsed_cover.value, list: parsed_list.value, reference: parsed_reference.value } };
                    })(value["urls"]);
                  })();
                  if (!parsed_urls.success) {
                    return { success: false, reason: parsed_urls.reason };
                  }
                  return {
                    success: true,
                    value: {
                      bookmarked: parsed_bookmarked.value,
                      dataId: parsed_dataId.value,
                      rating: parsed_rating.value,
                      referenceNumber: parsed_referenceNumber.value,
                      snippet: parsed_snippet.value,
                      sourceTypeString: parsed_sourceTypeString.value,
                      title: parsed_title.value,
                      urls: parsed_urls.value,
                    },
                  };
                })(value);
              });
              if (parsed.find((value) => !value.success) !== undefined) {
                return {
                  success: false,
                  reason: `[#/components/schemas/AskGetabstractAnswer/contextDocs]: Reason(s): '${parsed
                    .filter((p) => !p.success)
                    .map((p) => p.reason)
                    .join(", ")}'.`,
                };
              }
              return {
                success: true,
                value: parsed.map((entry) => {
                  assert(entry.success == true);
                  return entry.value;
                }),
              };
            })(value["contextDocs"]);
          })();
          if (!parsed_contextDocs.success) {
            return { success: false, reason: parsed_contextDocs.reason };
          }
          if (!hasProp(value, "detectedLanguageLabel")) {
            return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/detectedLanguageLabel]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'detectedLanguageLabel'.` };
          }
          const parsed_detectedLanguageLabel = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/detectedLanguageLabel]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["detectedLanguageLabel"]);
          })();
          if (!parsed_detectedLanguageLabel.success) {
            return { success: false, reason: parsed_detectedLanguageLabel.reason };
          }
          if (!hasProp(value, "previousQuestionUuid")) {
            return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/previousQuestionUuid]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'previousQuestionUuid'.` };
          }
          const parsed_previousQuestionUuid = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/previousQuestionUuid]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["previousQuestionUuid"]);
          })();
          if (!parsed_previousQuestionUuid.success) {
            return { success: false, reason: parsed_previousQuestionUuid.reason };
          }
          if (!hasProp(value, "question")) {
            return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/question]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'question'.` };
          }
          const parsed_question = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/question]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["question"]);
          })();
          if (!parsed_question.success) {
            return { success: false, reason: parsed_question.reason };
          }
          if (!hasProp(value, "questionUuid")) {
            return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/questionUuid]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'questionUuid'.` };
          }
          const parsed_questionUuid = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/questionUuid]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["questionUuid"]);
          })();
          if (!parsed_questionUuid.success) {
            return { success: false, reason: parsed_questionUuid.reason };
          }
          if (!hasProp(value, "relatedActionables")) {
            return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/relatedActionables]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'relatedActionables'.` };
          }
          const parsed_relatedActionables = ((): ParserResult<ActionableMiniView[]> => {
            return ((value: unknown): ParserResult<ActionableMiniView[]> => {
              if (!isArray(value)) {
                return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/relatedActionables]: '${value}' expected to be an array.` };
              }
              const parsed = value.map((value: unknown): ParserResult<ActionableMiniView> => {
                return ((
                  value: unknown,
                ): ParserResult<{
                  actionableId: bigint;
                  coverUri: string;
                  name: string;
                  title: string;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/ActionableMiniView]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/ActionableMiniView]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "actionableId")) {
                    return { success: false, reason: `[#/components/schemas/ActionableMiniView/actionableId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'actionableId'.` };
                  }
                  const parsed_actionableId = ((): ParserResult<bigint> => {
                    return ((value: unknown): ParserResult<bigint> => {
                      if (typeof value === "number") {
                        return { success: true, value: BigInt(value) };
                      }
                      if (typeof value === "bigint") {
                        return { success: true, value: value };
                      }
                      return { success: false, reason: `[#/components/schemas/ActionableMiniView/actionableId]: '${value}' expected to be of type bigint or number.` };
                    })(value["actionableId"]);
                  })();
                  if (!parsed_actionableId.success) {
                    return { success: false, reason: parsed_actionableId.reason };
                  }
                  if (!hasProp(value, "coverUri")) {
                    return { success: false, reason: `[#/components/schemas/ActionableMiniView/coverUri]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'coverUri'.` };
                  }
                  const parsed_coverUri = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/ActionableMiniView/coverUri]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["coverUri"]);
                  })();
                  if (!parsed_coverUri.success) {
                    return { success: false, reason: parsed_coverUri.reason };
                  }
                  if (!hasProp(value, "name")) {
                    return { success: false, reason: `[#/components/schemas/ActionableMiniView/name]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'name'.` };
                  }
                  const parsed_name = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/ActionableMiniView/name]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["name"]);
                  })();
                  if (!parsed_name.success) {
                    return { success: false, reason: parsed_name.reason };
                  }
                  if (!hasProp(value, "title")) {
                    return { success: false, reason: `[#/components/schemas/ActionableMiniView/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
                  }
                  const parsed_title = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/ActionableMiniView/title]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["title"]);
                  })();
                  if (!parsed_title.success) {
                    return { success: false, reason: parsed_title.reason };
                  }
                  return { success: true, value: { actionableId: parsed_actionableId.value, coverUri: parsed_coverUri.value, name: parsed_name.value, title: parsed_title.value } };
                })(value);
              });
              if (parsed.find((value) => !value.success) !== undefined) {
                return {
                  success: false,
                  reason: `[#/components/schemas/AskGetabstractAnswer/relatedActionables]: Reason(s): '${parsed
                    .filter((p) => !p.success)
                    .map((p) => p.reason)
                    .join(", ")}'.`,
                };
              }
              return {
                success: true,
                value: parsed.map((entry) => {
                  assert(entry.success == true);
                  return entry.value;
                }),
              };
            })(value["relatedActionables"]);
          })();
          if (!parsed_relatedActionables.success) {
            return { success: false, reason: parsed_relatedActionables.reason };
          }
          if (!hasProp(value, "relatedQuestions")) {
            return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/relatedQuestions]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'relatedQuestions'.` };
          }
          const parsed_relatedQuestions = ((): ParserResult<string[]> => {
            return ((value: unknown): ParserResult<string[]> => {
              if (!isArray(value)) {
                return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/relatedQuestions]: '${value}' expected to be an array.` };
              }
              const parsed = value.map((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/relatedQuestions]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              });
              if (parsed.find((value) => !value.success) !== undefined) {
                return {
                  success: false,
                  reason: `[#/components/schemas/AskGetabstractAnswer/relatedQuestions]: Reason(s): '${parsed
                    .filter((p) => !p.success)
                    .map((p) => p.reason)
                    .join(", ")}'.`,
                };
              }
              return {
                success: true,
                value: parsed.map((entry) => {
                  assert(entry.success == true);
                  return entry.value;
                }),
              };
            })(value["relatedQuestions"]);
          })();
          if (!parsed_relatedQuestions.success) {
            return { success: false, reason: parsed_relatedQuestions.reason };
          }
          if (!hasProp(value, "status")) {
            return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/status]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'status'.` };
          }
          const parsed_status = ((): ParserResult<AskGetabstractAnswerStatus> => {
            return ((value: unknown): ParserResult<AskGetabstractAnswerStatus> => {
              return ((value: unknown): ParserResult<"PROCESSING" | "FINISHED" | "NO_DOCS_FROM_VECTOR_DB" | "NO_DOCS_AFTER_FILTER" | "NO_REFERENCE_IN_ANSWER" | "GENERAL_ERROR" | "TIMEOUT"> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerStatus]: '${value}' expected to be of type string.` };
                }
                switch (value) {
                  case "PROCESSING":
                    return { success: true, value: "PROCESSING" };
                  case "FINISHED":
                    return { success: true, value: "FINISHED" };
                  case "NO_DOCS_FROM_VECTOR_DB":
                    return { success: true, value: "NO_DOCS_FROM_VECTOR_DB" };
                  case "NO_DOCS_AFTER_FILTER":
                    return { success: true, value: "NO_DOCS_AFTER_FILTER" };
                  case "NO_REFERENCE_IN_ANSWER":
                    return { success: true, value: "NO_REFERENCE_IN_ANSWER" };
                  case "GENERAL_ERROR":
                    return { success: true, value: "GENERAL_ERROR" };
                  case "TIMEOUT":
                    return { success: true, value: "TIMEOUT" };
                  default:
                    return {
                      success: false,
                      reason: `[#/components/schemas/AskGetabstractAnswerStatus]: '${value}' expected to be enum, one of 'PROCESSING, FINISHED, NO_DOCS_FROM_VECTOR_DB, NO_DOCS_AFTER_FILTER, NO_REFERENCE_IN_ANSWER, GENERAL_ERROR, TIMEOUT'.`,
                    };
                }
              })(value);
            })(value["status"]);
          })();
          if (!parsed_status.success) {
            return { success: false, reason: parsed_status.reason };
          }
          return {
            success: true,
            value: {
              answer: parsed_answer.value,
              contextDocs: parsed_contextDocs.value,
              detectedLanguageLabel: parsed_detectedLanguageLabel.value,
              previousQuestionUuid: parsed_previousQuestionUuid.value,
              question: parsed_question.value,
              questionUuid: parsed_questionUuid.value,
              relatedActionables: parsed_relatedActionables.value,
              relatedQuestions: parsed_relatedQuestions.value,
              status: parsed_status.value,
            },
          };
        })(value);
      })(value["current"]);
    })();
    if (!parsed_current.success) {
      return { success: false, reason: parsed_current.reason };
    }
    if (!hasProp(value, "history")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractQuestionAnswers/history]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'history'.` };
    }
    const parsed_history = ((): ParserResult<AskGetabstractAnswer[]> => {
      return ((value: unknown): ParserResult<AskGetabstractAnswer[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/AskGetabstractQuestionAnswers/history]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<AskGetabstractAnswer> => {
          return ((
            value: unknown,
          ): ParserResult<{
            answer: string;
            contextDocs: AskGetabstractAnswerContextDoc[];
            detectedLanguageLabel: string | null;
            previousQuestionUuid: string | null;
            question: string;
            questionUuid: string;
            relatedActionables: ActionableMiniView[];
            relatedQuestions: string[];
            status: AskGetabstractAnswerStatus;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "answer")) {
              return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/answer]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'answer'.` };
            }
            const parsed_answer = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/answer]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["answer"]);
            })();
            if (!parsed_answer.success) {
              return { success: false, reason: parsed_answer.reason };
            }
            if (!hasProp(value, "contextDocs")) {
              return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/contextDocs]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contextDocs'.` };
            }
            const parsed_contextDocs = ((): ParserResult<AskGetabstractAnswerContextDoc[]> => {
              return ((value: unknown): ParserResult<AskGetabstractAnswerContextDoc[]> => {
                if (!isArray(value)) {
                  return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/contextDocs]: '${value}' expected to be an array.` };
                }
                const parsed = value.map((value: unknown): ParserResult<AskGetabstractAnswerContextDoc> => {
                  return ((
                    value: unknown,
                  ): ParserResult<{
                    bookmarked: boolean;
                    dataId: number;
                    rating: number | null;
                    referenceNumber: number;
                    snippet: string;
                    sourceTypeString: string;
                    title: string;
                    urls: {
                      cover: string;
                      list: string;
                      reference: string;
                    };
                  }> => {
                    if (typeof value !== "object") {
                      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc]: '${value}' expected to be of type 'object'.` };
                    }
                    if (value === null) {
                      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc]: '${value}' expected to not be null.` };
                    }
                    if (!hasProp(value, "bookmarked")) {
                      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/bookmarked]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'bookmarked'.` };
                    }
                    const parsed_bookmarked = ((): ParserResult<boolean> => {
                      return ((value: unknown): ParserResult<boolean> => {
                        if (typeof value !== "boolean") {
                          return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/bookmarked]: '${value}' expected to be of type boolean.` };
                        }
                        return { success: true, value: value };
                      })(value["bookmarked"]);
                    })();
                    if (!parsed_bookmarked.success) {
                      return { success: false, reason: parsed_bookmarked.reason };
                    }
                    if (!hasProp(value, "dataId")) {
                      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/dataId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'dataId'.` };
                    }
                    const parsed_dataId = ((): ParserResult<number> => {
                      return ((value: unknown): ParserResult<number> => {
                        if (typeof value === "number") {
                          return { success: true, value: value };
                        }
                        return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/dataId]: '${value}' expected to be of type number.` };
                      })(value["dataId"]);
                    })();
                    if (!parsed_dataId.success) {
                      return { success: false, reason: parsed_dataId.reason };
                    }
                    if (!hasProp(value, "rating")) {
                      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/rating]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'rating'.` };
                    }
                    const parsed_rating = ((): ParserResult<number | null> => {
                      return ((value: unknown): ParserResult<number | null> => {
                        if (value === null) {
                          return { success: true, value: null };
                        }
                        if (typeof value === "number") {
                          return { success: true, value: value };
                        }
                        return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/rating]: '${value}' expected to be of type number.` };
                      })(value["rating"]);
                    })();
                    if (!parsed_rating.success) {
                      return { success: false, reason: parsed_rating.reason };
                    }
                    if (!hasProp(value, "referenceNumber")) {
                      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/referenceNumber]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'referenceNumber'.` };
                    }
                    const parsed_referenceNumber = ((): ParserResult<number> => {
                      return ((value: unknown): ParserResult<number> => {
                        if (typeof value === "number") {
                          return { success: true, value: value };
                        }
                        return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/referenceNumber]: '${value}' expected to be of type number.` };
                      })(value["referenceNumber"]);
                    })();
                    if (!parsed_referenceNumber.success) {
                      return { success: false, reason: parsed_referenceNumber.reason };
                    }
                    if (!hasProp(value, "snippet")) {
                      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/snippet]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'snippet'.` };
                    }
                    const parsed_snippet = ((): ParserResult<string> => {
                      return ((value: unknown): ParserResult<string> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/snippet]: '${value}' expected to be of type string.` };
                        }
                        return { success: true, value: value };
                      })(value["snippet"]);
                    })();
                    if (!parsed_snippet.success) {
                      return { success: false, reason: parsed_snippet.reason };
                    }
                    if (!hasProp(value, "sourceTypeString")) {
                      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/sourceTypeString]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'sourceTypeString'.` };
                    }
                    const parsed_sourceTypeString = ((): ParserResult<string> => {
                      return ((value: unknown): ParserResult<string> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/sourceTypeString]: '${value}' expected to be of type string.` };
                        }
                        return { success: true, value: value };
                      })(value["sourceTypeString"]);
                    })();
                    if (!parsed_sourceTypeString.success) {
                      return { success: false, reason: parsed_sourceTypeString.reason };
                    }
                    if (!hasProp(value, "title")) {
                      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
                    }
                    const parsed_title = ((): ParserResult<string> => {
                      return ((value: unknown): ParserResult<string> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/title]: '${value}' expected to be of type string.` };
                        }
                        return { success: true, value: value };
                      })(value["title"]);
                    })();
                    if (!parsed_title.success) {
                      return { success: false, reason: parsed_title.reason };
                    }
                    if (!hasProp(value, "urls")) {
                      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'urls'.` };
                    }
                    const parsed_urls = ((): ParserResult<{
                      cover: string;
                      list: string;
                      reference: string;
                    }> => {
                      return ((
                        value: unknown,
                      ): ParserResult<{
                        cover: string;
                        list: string;
                        reference: string;
                      }> => {
                        if (typeof value !== "object") {
                          return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls]: '${value}' expected to be of type 'object'.` };
                        }
                        if (value === null) {
                          return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls]: '${value}' expected to not be null.` };
                        }
                        if (!hasProp(value, "cover")) {
                          return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls/cover]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'cover'.` };
                        }
                        const parsed_cover = ((): ParserResult<string> => {
                          return ((value: unknown): ParserResult<string> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls/cover]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["cover"]);
                        })();
                        if (!parsed_cover.success) {
                          return { success: false, reason: parsed_cover.reason };
                        }
                        if (!hasProp(value, "list")) {
                          return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls/list]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'list'.` };
                        }
                        const parsed_list = ((): ParserResult<string> => {
                          return ((value: unknown): ParserResult<string> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls/list]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["list"]);
                        })();
                        if (!parsed_list.success) {
                          return { success: false, reason: parsed_list.reason };
                        }
                        if (!hasProp(value, "reference")) {
                          return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls/reference]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'reference'.` };
                        }
                        const parsed_reference = ((): ParserResult<string> => {
                          return ((value: unknown): ParserResult<string> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerContextDoc/urls/reference]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["reference"]);
                        })();
                        if (!parsed_reference.success) {
                          return { success: false, reason: parsed_reference.reason };
                        }
                        return { success: true, value: { cover: parsed_cover.value, list: parsed_list.value, reference: parsed_reference.value } };
                      })(value["urls"]);
                    })();
                    if (!parsed_urls.success) {
                      return { success: false, reason: parsed_urls.reason };
                    }
                    return {
                      success: true,
                      value: {
                        bookmarked: parsed_bookmarked.value,
                        dataId: parsed_dataId.value,
                        rating: parsed_rating.value,
                        referenceNumber: parsed_referenceNumber.value,
                        snippet: parsed_snippet.value,
                        sourceTypeString: parsed_sourceTypeString.value,
                        title: parsed_title.value,
                        urls: parsed_urls.value,
                      },
                    };
                  })(value);
                });
                if (parsed.find((value) => !value.success) !== undefined) {
                  return {
                    success: false,
                    reason: `[#/components/schemas/AskGetabstractAnswer/contextDocs]: Reason(s): '${parsed
                      .filter((p) => !p.success)
                      .map((p) => p.reason)
                      .join(", ")}'.`,
                  };
                }
                return {
                  success: true,
                  value: parsed.map((entry) => {
                    assert(entry.success == true);
                    return entry.value;
                  }),
                };
              })(value["contextDocs"]);
            })();
            if (!parsed_contextDocs.success) {
              return { success: false, reason: parsed_contextDocs.reason };
            }
            if (!hasProp(value, "detectedLanguageLabel")) {
              return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/detectedLanguageLabel]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'detectedLanguageLabel'.` };
            }
            const parsed_detectedLanguageLabel = ((): ParserResult<string | null> => {
              return ((value: unknown): ParserResult<string | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/detectedLanguageLabel]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["detectedLanguageLabel"]);
            })();
            if (!parsed_detectedLanguageLabel.success) {
              return { success: false, reason: parsed_detectedLanguageLabel.reason };
            }
            if (!hasProp(value, "previousQuestionUuid")) {
              return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/previousQuestionUuid]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'previousQuestionUuid'.` };
            }
            const parsed_previousQuestionUuid = ((): ParserResult<string | null> => {
              return ((value: unknown): ParserResult<string | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/previousQuestionUuid]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["previousQuestionUuid"]);
            })();
            if (!parsed_previousQuestionUuid.success) {
              return { success: false, reason: parsed_previousQuestionUuid.reason };
            }
            if (!hasProp(value, "question")) {
              return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/question]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'question'.` };
            }
            const parsed_question = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/question]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["question"]);
            })();
            if (!parsed_question.success) {
              return { success: false, reason: parsed_question.reason };
            }
            if (!hasProp(value, "questionUuid")) {
              return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/questionUuid]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'questionUuid'.` };
            }
            const parsed_questionUuid = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/questionUuid]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["questionUuid"]);
            })();
            if (!parsed_questionUuid.success) {
              return { success: false, reason: parsed_questionUuid.reason };
            }
            if (!hasProp(value, "relatedActionables")) {
              return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/relatedActionables]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'relatedActionables'.` };
            }
            const parsed_relatedActionables = ((): ParserResult<ActionableMiniView[]> => {
              return ((value: unknown): ParserResult<ActionableMiniView[]> => {
                if (!isArray(value)) {
                  return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/relatedActionables]: '${value}' expected to be an array.` };
                }
                const parsed = value.map((value: unknown): ParserResult<ActionableMiniView> => {
                  return ((
                    value: unknown,
                  ): ParserResult<{
                    actionableId: bigint;
                    coverUri: string;
                    name: string;
                    title: string;
                  }> => {
                    if (typeof value !== "object") {
                      return { success: false, reason: `[#/components/schemas/ActionableMiniView]: '${value}' expected to be of type 'object'.` };
                    }
                    if (value === null) {
                      return { success: false, reason: `[#/components/schemas/ActionableMiniView]: '${value}' expected to not be null.` };
                    }
                    if (!hasProp(value, "actionableId")) {
                      return { success: false, reason: `[#/components/schemas/ActionableMiniView/actionableId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'actionableId'.` };
                    }
                    const parsed_actionableId = ((): ParserResult<bigint> => {
                      return ((value: unknown): ParserResult<bigint> => {
                        if (typeof value === "number") {
                          return { success: true, value: BigInt(value) };
                        }
                        if (typeof value === "bigint") {
                          return { success: true, value: value };
                        }
                        return { success: false, reason: `[#/components/schemas/ActionableMiniView/actionableId]: '${value}' expected to be of type bigint or number.` };
                      })(value["actionableId"]);
                    })();
                    if (!parsed_actionableId.success) {
                      return { success: false, reason: parsed_actionableId.reason };
                    }
                    if (!hasProp(value, "coverUri")) {
                      return { success: false, reason: `[#/components/schemas/ActionableMiniView/coverUri]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'coverUri'.` };
                    }
                    const parsed_coverUri = ((): ParserResult<string> => {
                      return ((value: unknown): ParserResult<string> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/ActionableMiniView/coverUri]: '${value}' expected to be of type string.` };
                        }
                        return { success: true, value: value };
                      })(value["coverUri"]);
                    })();
                    if (!parsed_coverUri.success) {
                      return { success: false, reason: parsed_coverUri.reason };
                    }
                    if (!hasProp(value, "name")) {
                      return { success: false, reason: `[#/components/schemas/ActionableMiniView/name]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'name'.` };
                    }
                    const parsed_name = ((): ParserResult<string> => {
                      return ((value: unknown): ParserResult<string> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/ActionableMiniView/name]: '${value}' expected to be of type string.` };
                        }
                        return { success: true, value: value };
                      })(value["name"]);
                    })();
                    if (!parsed_name.success) {
                      return { success: false, reason: parsed_name.reason };
                    }
                    if (!hasProp(value, "title")) {
                      return { success: false, reason: `[#/components/schemas/ActionableMiniView/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
                    }
                    const parsed_title = ((): ParserResult<string> => {
                      return ((value: unknown): ParserResult<string> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/ActionableMiniView/title]: '${value}' expected to be of type string.` };
                        }
                        return { success: true, value: value };
                      })(value["title"]);
                    })();
                    if (!parsed_title.success) {
                      return { success: false, reason: parsed_title.reason };
                    }
                    return { success: true, value: { actionableId: parsed_actionableId.value, coverUri: parsed_coverUri.value, name: parsed_name.value, title: parsed_title.value } };
                  })(value);
                });
                if (parsed.find((value) => !value.success) !== undefined) {
                  return {
                    success: false,
                    reason: `[#/components/schemas/AskGetabstractAnswer/relatedActionables]: Reason(s): '${parsed
                      .filter((p) => !p.success)
                      .map((p) => p.reason)
                      .join(", ")}'.`,
                  };
                }
                return {
                  success: true,
                  value: parsed.map((entry) => {
                    assert(entry.success == true);
                    return entry.value;
                  }),
                };
              })(value["relatedActionables"]);
            })();
            if (!parsed_relatedActionables.success) {
              return { success: false, reason: parsed_relatedActionables.reason };
            }
            if (!hasProp(value, "relatedQuestions")) {
              return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/relatedQuestions]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'relatedQuestions'.` };
            }
            const parsed_relatedQuestions = ((): ParserResult<string[]> => {
              return ((value: unknown): ParserResult<string[]> => {
                if (!isArray(value)) {
                  return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/relatedQuestions]: '${value}' expected to be an array.` };
                }
                const parsed = value.map((value: unknown): ParserResult<string> => {
                  if (typeof value !== "string") {
                    return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/relatedQuestions]: '${value}' expected to be of type string.` };
                  }
                  return { success: true, value: value };
                });
                if (parsed.find((value) => !value.success) !== undefined) {
                  return {
                    success: false,
                    reason: `[#/components/schemas/AskGetabstractAnswer/relatedQuestions]: Reason(s): '${parsed
                      .filter((p) => !p.success)
                      .map((p) => p.reason)
                      .join(", ")}'.`,
                  };
                }
                return {
                  success: true,
                  value: parsed.map((entry) => {
                    assert(entry.success == true);
                    return entry.value;
                  }),
                };
              })(value["relatedQuestions"]);
            })();
            if (!parsed_relatedQuestions.success) {
              return { success: false, reason: parsed_relatedQuestions.reason };
            }
            if (!hasProp(value, "status")) {
              return { success: false, reason: `[#/components/schemas/AskGetabstractAnswer/status]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'status'.` };
            }
            const parsed_status = ((): ParserResult<AskGetabstractAnswerStatus> => {
              return ((value: unknown): ParserResult<AskGetabstractAnswerStatus> => {
                return ((value: unknown): ParserResult<"PROCESSING" | "FINISHED" | "NO_DOCS_FROM_VECTOR_DB" | "NO_DOCS_AFTER_FILTER" | "NO_REFERENCE_IN_ANSWER" | "GENERAL_ERROR" | "TIMEOUT"> => {
                  if (typeof value !== "string") {
                    return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerStatus]: '${value}' expected to be of type string.` };
                  }
                  switch (value) {
                    case "PROCESSING":
                      return { success: true, value: "PROCESSING" };
                    case "FINISHED":
                      return { success: true, value: "FINISHED" };
                    case "NO_DOCS_FROM_VECTOR_DB":
                      return { success: true, value: "NO_DOCS_FROM_VECTOR_DB" };
                    case "NO_DOCS_AFTER_FILTER":
                      return { success: true, value: "NO_DOCS_AFTER_FILTER" };
                    case "NO_REFERENCE_IN_ANSWER":
                      return { success: true, value: "NO_REFERENCE_IN_ANSWER" };
                    case "GENERAL_ERROR":
                      return { success: true, value: "GENERAL_ERROR" };
                    case "TIMEOUT":
                      return { success: true, value: "TIMEOUT" };
                    default:
                      return {
                        success: false,
                        reason: `[#/components/schemas/AskGetabstractAnswerStatus]: '${value}' expected to be enum, one of 'PROCESSING, FINISHED, NO_DOCS_FROM_VECTOR_DB, NO_DOCS_AFTER_FILTER, NO_REFERENCE_IN_ANSWER, GENERAL_ERROR, TIMEOUT'.`,
                      };
                  }
                })(value);
              })(value["status"]);
            })();
            if (!parsed_status.success) {
              return { success: false, reason: parsed_status.reason };
            }
            return {
              success: true,
              value: {
                answer: parsed_answer.value,
                contextDocs: parsed_contextDocs.value,
                detectedLanguageLabel: parsed_detectedLanguageLabel.value,
                previousQuestionUuid: parsed_previousQuestionUuid.value,
                question: parsed_question.value,
                questionUuid: parsed_questionUuid.value,
                relatedActionables: parsed_relatedActionables.value,
                relatedQuestions: parsed_relatedQuestions.value,
                status: parsed_status.value,
              },
            };
          })(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/AskGetabstractQuestionAnswers/history]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["history"]);
    })();
    if (!parsed_history.success) {
      return { success: false, reason: parsed_history.reason };
    }
    return { success: true, value: { current: parsed_current.value, history: parsed_history.value } };
  })(parseJsonWithNumbersAsBigint(str));
}
